import {
  FEATURE_STATUS_COMPLETED,
  FEATURE_STATUS_FAILED,
  FEATURE_STATUS_PENDING,
  FEATURE_STATUS_RERUNNING,
} from "config";

type BudgetFeatureMetadata = {
  error?: string;
  is_fallback?: boolean;
  synced_from_data?: boolean;
  persisted_at?: string;
};

type ResolveBudgetAiRunStateParams = {
  hasBudgetFeature: boolean;
  hasValidIds: boolean;
  hasAnyFeatureStatuses: boolean;
  hasBudgetStatus: boolean;
  status: string | undefined;
  metadata?: unknown;
};

export const resolveEffectiveBudgetFeatureStatus = (
  status: string | undefined,
  metadata: unknown
): string | undefined => {
  if (status !== FEATURE_STATUS_COMPLETED) {
    return status;
  }

  const meta = metadata as BudgetFeatureMetadata | undefined;
  if (meta?.error && !meta.is_fallback && !meta.synced_from_data && !meta.persisted_at) {
    return FEATURE_STATUS_FAILED;
  }

  return status;
};

export const resolveBudgetAiRunState = ({
  hasBudgetFeature,
  hasValidIds,
  hasAnyFeatureStatuses,
  hasBudgetStatus,
  status,
  metadata,
}: ResolveBudgetAiRunStateParams) => {
  const effectiveStatus = resolveEffectiveBudgetFeatureStatus(status, metadata);
  const isBudgetRerunning = effectiveStatus === FEATURE_STATUS_RERUNNING;
  const isBudgetPending = effectiveStatus === FEATURE_STATUS_PENDING;
  /** True for first-run PENDING and RERUNNING — drives the AI pipeline overlay. */
  const isBudgetAiRunning = isBudgetPending || isBudgetRerunning;
  const noBudgetStatusYet = hasValidIds && (!hasAnyFeatureStatuses || !hasBudgetStatus);
  const hasPollableBudgetStatus = hasBudgetFeature || hasBudgetStatus;

  return {
    isBudgetRerunning,
    isBudgetAiRunning,
    shouldPollProjectStatus:
      (hasPollableBudgetStatus && isBudgetAiRunning) || (hasBudgetFeature && noBudgetStatusYet),
  };
};
